import { useCallback, useState } from 'react';
import { StorageType } from '../../utilities/constants/common';
import {
  getStorage,
  isStorageAvailable,
} from '../../utilities/helpers/storage';
import { logError } from '../../utilities/helpers/errors';

export const usePersistedState = <T>(
  key: string,
  initialValue: T,
  storageType: StorageType = StorageType.LOCAL
): [T, React.Dispatch<React.SetStateAction<T>>] => {
  const storage = isStorageAvailable(storageType) && getStorage(storageType);

  const [storedValue, setStoredValue] = useState(() => {
    try {
      let item;

      if (storage) {
        item = storage.getItem(key);
      }
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      logError(error);
      return initialValue;
    }
  });

  const setValue = useCallback(
    (value: unknown) => {
      try {
        const valueToStore =
          value instanceof Function ? value(storedValue) : value;

        setStoredValue(valueToStore);

        if (storage) {
          storage.setItem(key, JSON.stringify(valueToStore));
        }
      } catch (error) {
        logError(error);
      }
    },
    [key, storage, storedValue]
  );

  return [storedValue, setValue];
};
